import {
	FETCH_AUTRE_ENTITES_SUCCESS,
	POST_VEHICULE_CONFIG_BEGIN,
	POST_VEHICULE_CONFIG_SUCCESS,
	POST_VEHICULE_CONFIG_ERROR,
	POST_VEHICULE_CONFIG_RESET,
	DELETE_VEHICULE_CONFIG_BEGIN,
	DELETE_VEHICULE_CONFIG_SUCCESS,
	DELETE_VEHICULE_CONFIG_ERROR,
	DELETE_VEHICULE_CONFIG_RESET,
	UPDATE_MASTER_VEHICULE_DOCS,
	FETCH_FLOTTE_SUCCESS,
	PUT_VEHICULE_FICHE_SUCCESS,
	SORTIE_VEHICULE_BEGIN,
	SORTIE_VEHICULE_SUCCESS,
	SORTIE_VEHICULE_ERROR,
	SORTIE_VEHICULE_RESET,
} from "../actions/autreActions"
import {
	FETCH_EMPLOYES_BEGIN,
	FETCH_EMPLOYES_SUCCESS,
	FETCH_EMPLOYES_ERROR,
	POST_EMPLOYES_BEGIN,
	POST_EMPLOYES_SUCCESS,
	POST_EMPLOYES_ERROR,
	POST_EMPLOYES_RESET,
	DELETE_EMPLOYE_BEGIN,
	DELETE_EMPLOYE_SUCCESS,
	DELETE_EMPLOYE_ERROR,
	DELETE_EMPLOYE_RESET,
} from "../actions/depannageActions"

// Slice "master" : données de référence de l'entreprise (entité master,
// véhicules, employés…) + leurs états async — consolidées ici au fil de la
// migration de structure. Convention : les slices *Reducer sont repensées.

// Bridge legacy : le VehiculeSerializer partagé émet encore les dates en
// "DD-MM-YYYY" (consommé par l'ancien Vehicule.js). Côté flotte V2 on travaille
// en ISO (input type=date) → on normalise à l'entrée du store. Le jour où le
// serializer passe en ISO, ce helper devient un no-op.
export const frToIso = (d) => {
	if (!d || typeof d !== "string") return d || ""
	const parts = d.split("-")
	if (parts.length === 3 && parts[0].length === 2) {
		return `${parts[2]}-${parts[1]}-${parts[0]}`
	}
	return d
}
const vehiculesToIso = (list) =>
	(list || []).map((v) => ({
		...v,
		date_mise_en_circu: frToIso(v.date_mise_en_circu),
		expertise_le: frToIso(v.expertise_le),
	}))

const initialState = {
	masterEntite: {},
	masterVehicules: [],
	groups: [],
	employes: [],
	fetchEmployes: { loading: false, error: false, errorDetails: {} },
	postEmploye: { saved: false, saving: false, error: false, errorFields: [] },
	deleteEmploye: { deleting: false, deleted: false, error: false },
	postVehicule: {
		saved: false,
		saving: false,
		error: false,
		errorFields: [],
	},
	deleteVehicule: { deleting: false, deleted: false, error: false },
	sortieVehicule: { saving: false, saved: false, error: false },
}

export default function masterReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_AUTRE_ENTITES_SUCCESS:
			return {
				...state,
				masterEntite: action.payload.master_entite,
				masterVehicules: vehiculesToIso(
					action.payload.master_vehicules,
				),
				groups: action.payload.groups,
			}
		// POST VEHICULE (config flotte)
		case POST_VEHICULE_CONFIG_BEGIN:
			return {
				...state,
				postVehicule: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_VEHICULE_CONFIG_SUCCESS:
			return {
				...state,
				masterVehicules: vehiculesToIso(action.payload.vehicules),
				postVehicule: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// Accès dédié de la fiche d'entretien : UN véhicule revient. On le
		// remplace dans la flotte s'il y est (jamais d'ajout : un véhicule
		// absent de la flotte active n'a pas à y apparaître).
		case PUT_VEHICULE_FICHE_SUCCESS: {
			const [veh] = vehiculesToIso([action.payload.vehicule])
			return {
				...state,
				masterVehicules: state.masterVehicules.map((v) =>
					v.id === veh.id ? veh : v,
				),
				postVehicule: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		}
		case POST_VEHICULE_CONFIG_ERROR:
			return {
				...state,
				postVehicule: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_VEHICULE_CONFIG_RESET:
			return {
				...state,
				postVehicule: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// DELETE VEHICULE (config flotte)
		case DELETE_VEHICULE_CONFIG_BEGIN:
			return {
				...state,
				deleteVehicule: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_VEHICULE_CONFIG_SUCCESS:
			return {
				...state,
				masterVehicules: vehiculesToIso(action.payload.vehicules),
				deleteVehicule: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_VEHICULE_CONFIG_ERROR:
			return {
				...state,
				deleteVehicule: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_VEHICULE_CONFIG_RESET:
			return {
				...state,
				deleteVehicule: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		case SORTIE_VEHICULE_BEGIN:
			return {
				...state,
				sortieVehicule: { saving: true, saved: false, error: false },
			}
		case SORTIE_VEHICULE_SUCCESS:
			return {
				...state,
				sortieVehicule: { saving: false, saved: true, error: false },
			}
		case SORTIE_VEHICULE_ERROR:
			return {
				...state,
				sortieVehicule: {
					saving: false,
					saved: false,
					error: action.payload.error,
				},
			}
		case SORTIE_VEHICULE_RESET:
			return {
				...state,
				sortieVehicule: { saving: false, saved: false, error: false },
			}
		case FETCH_FLOTTE_SUCCESS:
			return {
				...state,
				masterVehicules: vehiculesToIso(action.payload.vehicules),
			}
		case UPDATE_MASTER_VEHICULE_DOCS:
			return {
				...state,
				masterVehicules: state.masterVehicules.map((v) =>
					v.id === action.payload.id
						? {
								...v,
								files: action.payload.docs.files,
								carte_grise: action.payload.docs.carte_grise,
							}
						: v,
				),
			}
		// FETCH EMPLOYES
		case FETCH_EMPLOYES_BEGIN:
			return { ...state, fetchEmployes: { loading: true, error: null } }
		case FETCH_EMPLOYES_SUCCESS:
			return {
				...state,
				employes: action.payload.employes,
				fetchEmployes: { loading: false },
			}
		case FETCH_EMPLOYES_ERROR:
			return {
				...state,
				fetchEmployes: {
					loading: false,
					error: true,
					errorDetails: action.payload,
				},
			}
		// POST EMPLOYES
		case POST_EMPLOYES_BEGIN:
			return {
				...state,
				postEmploye: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_EMPLOYES_ERROR:
			return {
				...state,
				postEmploye: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_EMPLOYES_SUCCESS:
			return {
				...state,
				employes: action.payload.employes,
				postEmploye: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_EMPLOYES_RESET:
			return {
				...state,
				postEmploye: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// DELETE EMPLOYE
		case DELETE_EMPLOYE_BEGIN:
			return {
				...state,
				deleteEmploye: { deleted: false, deleting: true, error: false },
			}
		case DELETE_EMPLOYE_ERROR:
			return {
				...state,
				deleteEmploye: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_EMPLOYE_SUCCESS:
			return {
				...state,
				employes: action.payload.employes,
				deleteEmploye: { deleted: true, deleting: false, error: false },
			}
		case DELETE_EMPLOYE_RESET:
			return {
				...state,
				deleteEmploye: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		case "GET_EMPLOYES":
			return { ...state, employes: action.payload }
		case "SET_DEPANNEUR": {
			const i = state.employes.findIndex((e) => e.id === action.value.id)
			if (i !== -1) {
				return {
					...state,
					employes: [
						...state.employes.slice(0, i),
						action.value,
						...state.employes.slice(i + 1),
					],
				}
			}
			return { ...state, employes: [...state.employes, action.value] }
		}
		case "REMOVE_DEPANNEUR":
			return {
				...state,
				employes: state.employes.filter((e) => e.id !== action.value),
			}
		default:
			return state
	}
}
